import layout from '@/views/layout/layout.vue'
export default [{
    path: '/',
    redirect: '/home',
    component: layout,
    hidden: true,
    children: [{
        path: 'home',
        component: () => import('@/views/home/index.vue'),
        name: 'home',
        meta: {
          title: '主页'
        }
      },
      {
        path: 'userinfo',
        component: () => import('@/views/userinfo/index.vue'),
        name: 'userinfo',
        meta: {
          title: '个人中心'
        },
        redirect: '/userinfo/profile',
        children: [
          {
            path: 'profile',
            component: () => import('@/views/userinfo/profile.vue'),
            name: 'profile',
            meta: {
              title: '账户概览'
            },
          },
          {
            path: 'orderlist',
            component: () => import('@/views/userinfo/orderlist.vue'),
            name: 'orderlist',
            meta: {
              title: '货单记录'
            },
          },
          {
            path: 'saledetail',
            component: () => import('@/views/userinfo/saledetail.vue'),
            name: 'saledetail',
            meta: {
              title: '交易记录'
            },
          },
          {
            path: 'withdraw',
            component: () => import('@/views/userinfo/withdraw.vue'),
            name: 'withdraw',
            meta: {
              title: '提现'
            },
          },,
          {
            path: 'reduce',
            component: () => import('@/views/userinfo/reduce.vue'),
            name: 'reduce',
            meta: {
              title: '加速回收'
            },
          },
          {
            path: 'message',
            component: () => import('@/views/userinfo/message.vue'),
            name: 'message',
            meta: {
              title: '消息'
            },
          },
          {
            path: 'bill',
            component: () => import('@/views/userinfo/bill.vue'),
            name: 'bill',
            meta: {
              title: '账单'
            },
          },
          {
            path: 'settings',
            component: () => import('@/views/userinfo/settings.vue'),
            name: 'settings',
            meta: {
              title: '设置'
            },
          }
        ]
      },
      {
        path: 'login',
        component: () => import('@/views/login/index.vue'),
        name: 'login',
        meta: {
          title: '登录'
        }
      },
      {
        path: 'forgetpwd',
        component: () => import('@/views/forgetpwd/index.vue'),
        name: 'forgetpwd',
        meta: {
          title: '找回密码'
        }
      },
      {
        path: 'register',
        component: () => import('@/views/register/index.vue'),
        name: 'register',
        meta: {
          title: '注册'
        }
      },
      {
        path: 'help',
        component: () => import('@/views/help/index.vue'),
        name: 'help',
        meta: {
          title: '帮助中心'
        }
      },
      {
        path: 'recycle',
        component: () => import('@/views/recycle/index.vue'),
        name: 'recycle',
        meta: {
          title: '卡券回收'
        }
      },
      {
        path: 'success',
        component: () => import('@/views/success/index.vue'),
        name: 'success',
        meta: {
          title: '成功'
        }
      },
      {
        path: '404',
        component: () => import('@/views/error/404.vue'),
        name: '404',
        meta: {
          title: '404'
        }
      },
      {
        path: '500',
        component: () => import('@/views/error/500.vue'),
        name: '500',
        meta: {
          title: '500'
        }
      },
    ]
  }
]


// WEBPACK FOOTER //
// ./src/router/routes.js